Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.MappingTemplate = (function () {

    function MappingTemplate() {

        App.Forms.DataImport = App.Forms.DataImport || {};
        App.Forms.DataImport.MappingTemplate = this;

        this.createBaseStructure = function () {

            this.rootEl = document.createElement('div');
            this.rootEl.className = 'mappingTemplateSection';

        };

        this.editTemplate = function () {
            var id = this.templatePicklist.getValue();
            var uploadedFile = App.Forms.DataImport.uploadFile;

            if (id === "NEW") {

                new Greenmile.Components.AlertModal("Greenmile.DataImport.noLayoutSelected")
                    .show();

            } else if (!uploadedFile) {

                new Greenmile.Components.AlertModal('Greenmile.DataImport.noFileFound')
                    .show();
            } else {
                var ajax = new Monet.Ajax();
                ajax.url = "TextFileLayout/" + id;
                ajax.method = "GET";
                ajax.success = function (data) {
                    Greenmile.DataImport.MappingScreenFactory.showMapScreen(uploadedFile, data);
                };
                ajax.error = function (error) {
                    Greenmile.DataImport.Utils.showErrorMessage(error);
                };
                ajax.send();
            }
        };

        this.deleteTemplate = function () {
            var id = this.templatePicklist.getValue();

            if (id === "NEW") {

                new Greenmile.Components.AlertModal("Greenmile.DataImport.noLayoutSelected")
                    .show();

            } else {
                const deleteFileLayout = () => {
                    const ajax = new Monet.Ajax();
                    ajax.url = "TextFileLayout/" + id;
                    ajax.method = "DELETE";
                    ajax.success = function () {
                        App.Forms.DataImport.MappingTemplate.refreshList();
                    };
                    ajax.error = function (error) {
                        Greenmile.DataImport.Utils.showErrorMessage(JSON.parse(error.response));
                    };
                    ajax.send();
                }

                new Greenmile.Components.AlertModal("textfile.template.delete.confirm",
                    null,
                    deleteFileLayout
                )
                .show();
            }
        };

        this.refreshList = function () {
            this.templatePicklist.setCustomFilter(JSON.stringify({
                rootEntity: App.Forms.DataImport.EntityList.getSelected()
            }));

            this.templatePicklist.rootEl.removeChild(this.templatePicklist.input);
            this.templatePicklist.render();
            this.templatePicklist.setListenerOnChange(function () {
                if (this.value === "NEW") {
                    document.querySelector("#editTemplate").style.display = "none";
                    document.querySelector("#deleteTemplate").style.display = "none";
                } else {
                    document.querySelector("#editTemplate").style.display = "block";
                    document.querySelector("#deleteTemplate").style.display = "block";
                }
            });
        };

        this.createTemplateList = function () {
            this.templatePicklist = new Monet.UI.Fields.PickList();
            this.templatePicklist.setId('TemplateList');
            this.templatePicklist.setDisplayKey('name');
            this.templatePicklist.setCustomUrl('/TextFileLayout/FindByTenantAndRootEntity');
            this.templatePicklist.setCustomFilter(JSON.stringify({
                rootEntity: App.Forms.DataImport.EntityList.getSelected()
            }));

            this.templatePicklist.render();
            this.templatePicklist.setTextLabel(Monet.I18n.getResourcesByKey('Greenmile.DataImport.TemplateList'));

            this.templatePicklist.addPostRender(function () {
                var firstOption = this.input.options[0];
                firstOption.value = 'NEW';
                firstOption.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.newTemplate');
                firstOption.selected = 'selected';
            }.bind(this.templatePicklist));
            this.templatePicklist.setListenerOnChange(function () {
                if (this.value === "NEW") {
                    document.querySelector("#editTemplate").style.display = "none";
                    document.querySelector("#deleteTemplate").style.display = "none";
                } else {
                    document.querySelector("#editTemplate").style.display = "block";
                    document.querySelector("#deleteTemplate").style.display = "block";
                }
            });

            App.Forms.DataImport.MappingTemplate.template = this.templatePicklist;

            var edit = new Monet.UI.Fields.Render({
                label: '',
                type: 'LINK',
                meta: {
                    customJavascript: "javascript: App.Forms.DataImport.MappingTemplate.editTemplate()"
                },
                defaultValue: 'Greenmile.DataImport.EditTemplate'
            }).render();

            edit.rootEl.style.display = "none";
            edit.setId('editTemplate');

            var del = new Monet.UI.Fields.Render({
                label: '',
                type: 'LINK',
                meta: {
                    customJavascript: "javascript: App.Forms.DataImport.MappingTemplate.deleteTemplate()"
                },
                defaultValue: 'Greenmile.DataImport.DeleteTemplate'
            }).render();

            del.rootEl.style.display = "none";
            del.setId('deleteTemplate');

            this.typeImportList = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.TypeImport',
                type: 'PICKLIST',
                fieldDomains: Greenmile.DataImport.Utils.getImportTypeDomains()

            }).render();

            this.typeImportList.removeOption(0);
            this.typeImportList.setId('TypeImport');
            this.typeImportList.setSelectedValue('PATCH');

            this.rootEl.appendChild(this.templatePicklist.rootEl);
            this.rootEl.appendChild(this.typeImportList.rootEl);
            this.rootEl.appendChild(edit.rootEl);
            this.rootEl.appendChild(del.rootEl);
        };

        this.getTypeImportSelected = () => {
            return this.typeImportList.getValue();
        }

        this.getValue = function () {
            var value = this.templatePicklist.input.value;
            if (value !== 'NEW') {
                value = this.templatePicklist.getValue();
            }
            return value;
        };

        this.setPostRenderRemoveNewOption = function () {
            this.templatePicklist.addPostRender(function () {

                var firstOption = this.input.options[0];
                if (firstOption.value === 'NEW') {
                    firstOption.value = '';
                    firstOption.innerHTML = ' ';
                }

            }.bind(this.templatePicklist));
        };

        this.render = function () {
            this.createBaseStructure();
            this.createTemplateList();

            return this.rootEl;
        };
    }

    return MappingTemplate;
}());
